import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  createDrawerNavigator,
  DrawerContentScrollView,
  DrawerItemList,
  DrawerItem,
} from '@react-navigation/drawer';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import React, {useState, useContext} from 'react';
import {
  Platform,
  Dimensions,
  Text,
  Button,
  ScrollView,
  Pressable,
  StyleSheet,
  View,
} from 'react-native';
import {
  NavigationContainer,
  useNavigation,
  createNavigationContainerRef,
  useNavigationState,
  useRoute,
} from '@react-navigation/native';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {large, useBreakpoint} from './breakpoints';
import CustomNavigationBar from './components/CustomNavigationBar';
import CustomNavigationDrawer from './components/CustomNavigationDrawer';
import {useToken} from './data/token';
import SignInScreen from './screens/SignInScreen';
import SplashScreen from './SplashScreen';
import BookmarkDetailScreen from './screens/links/BookmarkDetailScreen';
import ReadScreen from './screens/links/ReadScreen';
import UnreadScreen from './screens/links/UnreadScreen';
import TagListScreen from './screens/tags/TagListScreen';
import TaggedLinksScreen from './screens/tags/TaggedLinksScreen';

import DashboardScreen from './screens/users/DashboardScreen';
import DashboardForMobileScreen from './screens/users/DashboardForMobileScreen';
import CaseScreen from './screens/users/CaseScreen';
import CaseDiaryScreen from './screens/users/CaseDiaryScreen';
import TotalCaseScreen from './screens/users/TotalCaseScreen';
import CaseViewScreen from './screens/users/CaseViewScreen';
import DiaryHistoryScreen from './screens/users/DiaryHistoryScreen';

import DailyCaseListScreen from './screens/users/DailyCaseListScreen';
import MySearchListScreen from './screens/users/MySearchListScreen';
import MyCaseScreen from './screens/users/MyCaseScreen';
import CaseEntryScreen from './screens/users/CaseEntryScreen';
import CaseEditScreen from './screens/users/CaseEditScreen';
import SettingsScreen from './screens/users/SettingsScreen';
import ProfileScreen from './screens/users/ProfileScreen';
import PasswordChangeScreen from './screens/users/PasswordChangeScreen';
import CaseHistoryScreen from './screens/users/CaseHistoryScreen';
import AdminScreen from './screens/users/AdminScreen';

import LogOutScreen from './screens/users/LogOutScreen';
import homeScreen from './screens/home/homeScreen';
import webHomeScreen from './screens/webHomeScreen';
import MobileWebHomeScreen from './screens/users/MobileWebHomeScreen';
import registrationScreen from './screens/RegistrationScreen';
import {
  DefaultThemeColors,
  DarkThemeColors,
  ThemeOne,
  ThemeTwo,
} from './utils/constants/Colors';
import TopBar from '../src/shared/TopBar';

import MenuHover from '../src/shared/MenuHover';
const Colors2 = ThemeOne;
const windowWidth = Dimensions.get('window').width;
const linking = {
  config: {
    screens: {
      'Sign in': {
        initialRouteName: 'SignInScreen',
        screens: {
          SignInScreen: '/sign-in',
        },
      },
    },
  },
};
import Root from './Root';
import {GrBranchAdalotComponent} from './screens/users/GrBranchAdalot';
import {GrThanaAreaComponent} from './screens/users/GrThanaArea/GrThanaArea';
import {GrAdalotCreateComponent} from './screens/users/GrAdalotCreate/GrAdalotCreate';

const afterLogin = {
  config: {
    screens: {
      Dashboard: {
        initialRouteName: 'DashboardScreen',
        screens: {
          DashboardScreen: '/Dashboard',
        },
      },
      DashboardForMobile: {
        initialRouteName: 'DashboardForMobileScreen',
        screens: {
          DashboardForMobileScreen: '/DashboardForMobile',
        },
      },
      Case: {
        path: '/users/Case',
        initialRouteName: 'CaseDiaryScreen',
        screens: {
          CaseDiaryScreen: '/CaseDiaryScreen',
        },
      },
      'My Search List': {
        path: '/users/MySearchList',
        initialRouteName: 'MySearchListScreen',
        screens: {
          MySearchListScreen: '/MySearchList',
        },
      },
      'My Case': {
        path: '/users/Mycase',
        initialRouteName: 'MyCaseScreen',
        screens: {
          MycaseScreen: '/MyCase',
        },
      },

      'Daily Case List': {
        path: '/users/DailyCaseList',
        initialRouteName: 'DailyCaseListScreen',
        screens: {
          DailyCaseListScreen: '/DailyCaseList',
        },
      },
      Settings: {
        path: '/users/Settings',
        initialRouteName: 'SettingsScreen',
        screens: {
          SettingsScreen: '/Settings',
        },
      },
      'Log Out': {
        path: '/users/LogOutList',
        initialRouteName: 'LogOutScreen',
        screens: {
          LogOutScreen: '/LogOut',
        },
      },
    },
  },
};

const Stack = createNativeStackNavigator();
const stackScreenOptions = {
  header: props => <CustomNavigationBar {...props} />,
};

const SignIn = () => (
  <Stack.Navigator
    initialRouteName="SignInScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="SignInScreen"
      component={SignInScreen}
      options={{
        title: 'লগ ইন',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const Admin = () => (
  <Stack.Navigator
    initialRouteName="AdminScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="AdminScreen"
      component={AdminScreen}
      options={{
        title: 'অ্যাডমিন',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />

    <Stack.Screen
      name="grBranchAdalot"
      component={GrBranchAdalotComponent}
      options={{
        title: 'জি আর শাখা আদালত',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />

    <Stack.Screen
      name="grThanaArea"
      component={GrThanaAreaComponent}
      options={{
        title: 'জি আর  থানা / অঞ্চল ',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
    <Stack.Screen
      name="grAdalotCreate"
      component={GrAdalotCreateComponent}
      options={{
        title: 'জি আর আদালত যোগ',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

// FOR WEB & Mobile MENU

const HomeStack = createNativeStackNavigator();
const Home = () => (
  <Stack.Navigator
    initialRouteName="homeScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="homeScreen"
      component={homeScreen}
      options={{
        title: 'হোম',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);
const WebHome = () => (
  <Stack.Navigator
    initialRouteName="webHomeScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="webHomeScreen"
      component={webHomeScreen}
      options={{
        title: 'হোম',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const Registration = () => (
  <Stack.Navigator
    initialRouteName="registrationScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="registrationScreen"
      component={registrationScreen}
      options={{
        title: 'রেজিস্ট্রেশন',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const Dashboard = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="DashboardScreen"
      component={DashboardScreen}
      options={{
        title: 'ড্যাসবোর্ড',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const DashboardForMobile = () => (
  <Stack.Navigator
    initialRouteName="DashboardForMobileScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="DashboardForMobileScreen"
      component={DashboardForMobileScreen}
      options={{
        title: 'ড্যাসবোর্ড',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);
const WebHomedForMobile = () => (
  <Stack.Navigator
    initialRouteName="MobileWebHomeScreen"
    screenOptions={stackScreenOptions}
  >
    <Stack.Screen
      name="MobileWebHomeScreen"
      component={MobileWebHomeScreen}
      options={{
        title: 'হোম',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const MySearchList = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="MySearchListScreen"
      component={MySearchListScreen}
      options={{
        title: 'আমার ডায়েরী',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const Case = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="CaseEntry"
      component={CaseEntryScreen}
      options={{
        title: 'নতুন মামলা যোগ',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
    <Stack.Screen
      name="CaseEditScreen"
      component={CaseEditScreen}
      options={{
        title: 'Case Edit',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
    <Stack.Screen
      name="CaseDiaryScreen"
      component={CaseDiaryScreen}
      options={{
        title: 'Case Diary',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
    <Stack.Screen
      name="TotalCaseScreen"
      component={TotalCaseScreen}
      options={{
        title: 'সকল মামলা ও রেজিস্ট্রার',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />

    <Stack.Screen
      name="DiaryHistoryScreen"
      component={DiaryHistoryScreen}
      options={{
        title: 'Case Diary History',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />

    <Stack.Screen
      name="CaseViewScreen"
      component={CaseViewScreen}
      options={{
        title: 'Case Information',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const DailyCaseList = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="DailyCaseListScreen"
      component={DailyCaseListScreen}
      options={{
        title: 'দৈনিক কার্যতালিকা',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const MyCase = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="MyCaseScreen"
      component={MyCaseScreen}
      options={{
        title: 'মামলা খুজুন',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
    <Stack.Screen
      name="CaseHistoryScreen"
      component={CaseHistoryScreen}
      options={{
        title: 'Case History',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const CaseEntry = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="CaseEntryScreen"
      component={CaseEntryScreen}
      options={{
        title: 'Case Entry',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const Settings = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="ProfileScreen"
      component={ProfileScreen}
      options={{
        title: 'প্রোফাইল',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
    <Stack.Screen
      name="PasswordChangeScreen"
      component={PasswordChangeScreen}
      options={{
        title: 'পাসওয়ার্ড পরিবর্তন',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

const LogOut = () => (
  <Stack.Navigator screenOptions={stackScreenOptions}>
    <Stack.Screen
      name="LogOutScreen"
      component={LogOutScreen}
      options={{
        title: 'Log Out',
        headerShown: Platform.OS === 'web' && windowWidth >= 600 ? false : true,
      }}
    />
  </Stack.Navigator>
);

async function getUsername() {
  try {
    const jsonValue = await AsyncStorage.getItem('user_name');
    if (jsonValue !== null) {
      //console.log("user_name: "+JSON.parse(jsonValue));
      return JSON.parse(jsonValue);
    }
  } catch (err) {
    console.error(err);
  }
}

async function getPassword() {
  try {
    const jsonValue = await AsyncStorage.getItem('user_password');
    if (jsonValue !== null) {
      //console.log("user_password: "+JSON.parse(jsonValue));
      return JSON.parse(jsonValue);
    }
  } catch (err) {
    console.error(err);
  }
}

async function signOut() {
  alert('ff');
  //navigation.navigate('Sign in');
}

const Drawer = createDrawerNavigator();
const Tab = createMaterialTopTabNavigator();

const getDrawerTypeForBreakpoint = breakpoint =>
  breakpoint === large ? 'permanent' : 'back';

const DrawerNavigatorRoutes = props => {
  const [swipeEnabled, setSwipeEnabled] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  //const {isLoggedIn} = useState(true);
  const breakpoint = useBreakpoint();
  const drawerTypeForBreakpoint = getDrawerTypeForBreakpoint(breakpoint);

  const getPlatForm = Platform.OS === 'web' ? 'web' : '';
  const [isPlatForm, setIsPlatForm] = useState(getPlatForm);
  const [eventLog, updateEventLog] = React.useState([]);
  const [disabled, setDisabled] = React.useState(false);
  const [delay, setDelay] = React.useState(0);

  const handleEvent = eventName => {
    return () => {
      const limit = 10;
      updateEventLog(state => {
        const nextState = state.slice(0, limit - 1);
        nextState.unshift(eventName);
        return nextState;
      });
    };
  };
  //const windowHeight = Dimensions.get('window').height;
  //const {theme, changeThemeType} = useThemeContext();
  //console.log(windowWidth)
  // const tabHiddenRoutes = ['SettingDetails'];
  // React.useLayoutEffect(() => {
  //   if (tabHiddenRoutes.includes(getFocusedRouteNameFromRoute(route))) {
  //     navigation.setOptions({ tabBarStyle: { display: 'none' } });
  //   } else {
  //     navigation.setOptions({ tabBarStyle: { display: 'flex' } });
  //   }
  // }, [navigation, route]);

  getUsername().then(getUser => {
    getPassword().then(getPass => {
      if (getUser != undefined && getPass != undefined) setIsLoggedIn(true);
      getUser === '100' ? setIsAdmin(true) : setIsAdmin(false);
    });
  });
  //const route = useRoute();
  //const route = useRoute();
  // const routeName = getFocusedRouteNameFromRoute(route);
  // const route = navigation.current?.getCurrentRoute()
  const route = props.routeName;
  return Platform.OS === 'web' && windowWidth >= 600 ? (
    <>
      <TopBar />
      <Tab.Navigator
        // swipeEnabled={swipeEnabled}
        // swipeEnabled={false}
        initialRouteName="ড্যাসবোর্ড"
        screenOptions={() => {
          return {
            tabBarScrollEnabled: false,
            swipeEnabled: false,
            tabBarIndicator: () => null,

            tabBarStyle: {
              display: route === 'webHomeScreen' ? 'none' : 'flex',
              backgroundColor: '#fff',
              elevation: 15,
              height: 35,
              //  paddingLeft: 193,

              // পাশাপাশি রাখবে
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            },

            tabBarItemStyle: {
              width: 'auto',
              height: 35,
              //paddingHorizontal: 12,
              marginHorizontal: -10,

              justifyContent: 'center',
              alignItems: 'center',
            },

            tabBarActiveTintColor: '#000',
            tabBarInactiveTintColor: '#666',

            tabBarLabelStyle: {
              fontSize: 16,
              fontWeight: 'bold',
              padding: 0,
              margin: 0,
              textTransform: 'none',
              includeFontPadding: false,
            },
          };
        }}
      >
        <>
          {/* <Tab.Screen name="MobileWebHomeScreen" component={MobileWebHomeScreen} 
           options={{
             tabBarLabel: ({focused, color, size}) => (
               <Text style={{textAlign:'center',fontFamily:'SolaimanLipi', color: focused ? Colors2.top5 : color, fontWeight:'bold', textDecorationLine: focused ?'underline': 'none'}}>হোম</Text>
             ),}}
         />           */}
          <Tab.Screen
            name="ড্যাসবোর্ড"
            component={Dashboard}
            options={{
              tabBarLabel: ({focused, color}) => (
                <View
                  style={{
                    backgroundColor: focused ? '#0373bb' : '#fff',
                    height: 35,
                    //Width: 100,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 14,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderRadius: 2,
                    // marginBottom: -24,
                  }}
                >
                  <Text
                    style={{
                      //  fontSize: 20,
                      // Width: 'auto',
                      textAlign: 'center',
                      fontFamily: 'SolaimanLipi',
                      color: focused ? '#fff' : color,
                      fontWeight: 'bold',
                      includeFontPadding: false,
                    }}
                  >
                    ড্যাসবোর্ড
                  </Text>
                </View>
              ),
            }}
          />
          <Tab.Screen
            name="মামলা"
            component={Case}
            options={{
              tabBarLabel: ({focused, color, size}) => (
                <View
                  style={{
                    backgroundColor: focused ? '#0373bb' : '#fff',
                    height: 35,
                    //Width: 75,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 14,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderRadius: 2,
                    // marginBottom: -24,
                  }}
                >
                  <Text
                    style={{
                      // marginLeft: -250,
                      //  marginTop: 12,
                      // size: 20,
                      textAlign: 'center',
                      fontFamily: 'SolaimanLipi',
                      color: focused ? Colors2.top11 : color,
                      fontWeight: 'bold',
                    }}
                  >
                    মামলা
                  </Text>
                </View>
              ),
            }}
          />
          <Tab.Screen
            name="দৈনিক কার্যতালিকা"
            component={DailyCaseList}
            options={{
              tabBarLabel: ({focused, color, size}) => (
                <View
                  style={{
                    backgroundColor: focused ? '#0373bb' : '#fff',
                    height: 35,
                    // Width: 135,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 14,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderRadius: 2,
                    // marginBottom: -24,
                  }}
                >
                  <Text
                    style={{
                      // marginLeft: -250,
                      // marginTop: 12,
                      //  Width: 135,
                      // size: 20,
                      textAlign: 'center',
                      fontFamily: 'SolaimanLipi',
                      color: focused ? Colors2.top11 : color,
                      fontWeight: 'bold',
                      flexWrap: 'nowrap',
                    }}
                  >
                    দৈনিক কার্যতালিকা
                  </Text>
                </View>
              ),
            }}
          />
          <Tab.Screen
            name="মামলা খুজুন"
            component={MyCase}
            options={{
              tabBarLabel: ({focused, color, size}) => (
                <View
                  style={{
                    backgroundColor: focused ? '#0373bb' : '#fff',
                    height: 35,
                    // Width: 'auto',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 14,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderRadius: 2,
                    // marginBottom: -24,
                  }}
                >
                  <Text
                    style={{
                      // marginLeft: -250,
                      //  marginTop: 12,
                      // size: 20,
                      textAlign: 'center',
                      fontFamily: 'SolaimanLipi',
                      color: focused ? Colors2.top11 : color,
                      fontWeight: 'bold',
                    }}
                  >
                    মামলা খুজুন
                  </Text>
                </View>
              ),
            }}
          />
          <Tab.Screen
            name="আমার ডায়েরী"
            component={MySearchList}
            options={{
              tabBarLabel: ({focused, color, size}) => (
                <View
                  style={{
                    backgroundColor: focused ? '#0373bb' : '#fff',
                    height: 35,
                    // Width: 'auto',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 14,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderRadius: 2,
                    // marginBottom: -24,
                  }}
                >
                  <Text
                    style={{
                      // marginLeft: -250,
                      //  marginTop: 12,
                      // size: 20,
                      textAlign: 'center',
                      fontFamily: 'SolaimanLipi',
                      color: focused ? Colors2.top11 : color,
                      fontWeight: 'bold',
                    }}
                  >
                    আমার ডায়েরী
                  </Text>
                </View>
              ),
            }}
          />

          {/* <Tab.Screen name="প্রোফাইল" component={Settings}
          options={{
           tabBarLabel: ({focused, color, size}) => (
             <Text style={{textAlign:'center',fontFamily:'SolaimanLipi', color: focused ? Colors2.top5 : color, fontWeight:'bold', textDecorationLine: focused ?'underline': 'none' }}>প্রোফাইল</Text>
           ),}}
         /> */}
          {isAdmin ? (
            <Tab.Screen
              name="অ্যাডমিন"
              component={Admin}
              options={{
                tabBarLabel: ({focused, color, size}) => (
                  <View
                    style={{
                      backgroundColor: focused ? '#0373bb' : '#fff',
                      height: 35,
                      //  Width: 'auto',
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingHorizontal: 14,
                      borderWidth: 1,
                      borderColor: '#ccc',
                      borderRadius: 2,
                      // marginBottom: -24,
                    }}
                  >
                    <Text
                      style={{
                        // marginLeft: -250,
                        // marginTop: 12,
                        //  size: 20,
                        textAlign: 'center',
                        fontFamily: 'SolaimanLipi',
                        color: focused ? Colors2.top11 : color,
                        fontWeight: 'bold',
                        textDecorationLine: focused ? 'underline' : 'none',
                      }}
                    >
                      অ্যাডমিন
                    </Text>
                  </View>
                ),
              }}
            />
          ) : null}
          <Tab.Screen
            name="লগ আউট"
            component={LogOut}
            options={{
              tabBarLabel: ({focused, color, size}) => (
                <View
                  style={{
                    backgroundColor: focused ? '#0373bb' : '#fff',
                    height: 35,
                    //  Width: 'auto',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 14,
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderRadius: 2,
                    // marginBottom: -24,
                  }}
                >
                  <Text
                    style={{
                      // marginLeft: -250,
                      // marginTop: 12,
                      //  size: 20,
                      textAlign: 'center',
                      color: 'red',
                      fontFamily: 'SolaimanLipi',
                      fontWeight: 'bold',
                      textDecorationLine: focused ? 'underline' : 'none',
                    }}
                  >
                    লগ আউট
                  </Text>
                </View>
              ),
            }}
          />
        </>
        {/* ) : (
       <>
        
         <Tab.Screen  name="রেজিস্ট্রেশন" component={Registration} 
          options={{
           tabBarLabel: ({focused, color, size}) => (
             <Text style={{textAlign:'center', color: focused ? Colors2.top5 : color, fontWeight:'bold', textDecorationLine: focused ?'underline': 'none'  }}>রেজিস্ট্রেশন</Text>
           ),}}
         />
         
         <Tab.Screen name="লগ ইন" component={SignIn} 
          options={{
           tabBarLabel: ({focused, color, size}) => (
             <Text style={{textAlign:'center', color: focused ? Colors2.top5 : color, fontWeight:'bold', textDecorationLine: focused ?'underline': 'none'  }}>লগ ইন</Text>
           ),}}
         />
          <Tab.Screen name="হোম" component={WebHome} 
          options={{
           tabBarLabel: ({focused, color, size}) => (
             <Text style={{textAlign:'center', color: focused ? Colors2.top5 : color, fontWeight:'bold', textDecorationLine: focused ?'underline': 'none'  }}>হোম</Text>
           ),}}
         /> 
       
       </>
        
     )} */}
      </Tab.Navigator>
    </>
  ) : (
    <Drawer.Navigator
      initialRouteName="ড্যাসবোর্ড"
      screenOptions={{
        headerShown: false,
        drawerType: drawerTypeForBreakpoint,
        drawerStyle: {
          width: isPlatForm === 'web' && windowWidth >= 600 ? 0 : 250,
        },
      }}
      // screenOptions={{
      //   headerShown: false,
      //   drawerActiveBackgroundColor : '#419641',
      // drawerActiveTintColor: "#fffccc",
      // drawerInactiveTintColor: "white",
      //   color: '#fff',
      //   itemStyle: {marginVertical: 5, color: '#ffff'},
      //   labelStyle: {
      //     color: '#fff',
      //   },
      //   drawerStyle: {
      //     backgroundColor: '#c6cbef',
      //     width: 240,
      //   },
      //  // overlayColor: 'transparent',
      // }}
      drawerContentOptions={{
        activeTintColor: '#e91e63',
        itemStyle: {marginVertical: 5},
      }}
      drawerContent={props => <CustomNavigationDrawer {...props} />}
    >
      <>
        {/* { Platform.OS === 'web'?
         <Drawer.Screen name="MobileWebHomeScreen"  component={WebHomedForMobile}  />: null } */}
        {Platform.OS === 'web' ? (
          <Drawer.Screen name="ড্যাসবোর্ড" component={Dashboard} />
        ) : (
          <Drawer.Screen name="ড্যাসবোর্ড" component={DashboardForMobile} />
        )}
        <Drawer.Screen name="মামলা" component={Case} />
        <Drawer.Screen name="দৈনিক কার্যতালিকা" component={DailyCaseList} />
        <Drawer.Screen name="আমার ডায়েরী" component={MySearchList} />
        <Drawer.Screen name="মামলা খুজুন" component={MyCase} />
        {/* <Drawer.Screen name="প্রোফাইল" component={Settings}  />    */}
      </>
    </Drawer.Navigator>
  );
};

const styles = StyleSheet.create({
  title: {
    fontWeight: 'bold',
    fontSize: 30,
    padding: 4,
    textAlign: 'center',
  },
  scrollView: {flex: 1, backgroundColor: 'pink'},
  buttonLabel: {fontWeight: 'bold'},
  buttonInner: {
    height: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonRoot: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    margin: 0,
    padding: 5,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,

    elevation: 4,
  },
  buttonHovered: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  buttonFocused: {
    backgroundColor: 'rgba(0,0,0,0.3)',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
    elevation: 10,
  },
  buttonPressed: {
    backgroundColor: 'rgba(0,0,0,0.4)',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 9,
    },
    shadowOpacity: 0.5,
    shadowRadius: 12.35,
    elevation: 19,
  },
  pressable: {
    borderRadius: 5,
    padding: 10,
    borderWidth: 1,
    outlineWidth: 0,
    backgroundColor: '#fff',
  },
  hovered: {
    backgroundColor: '#f30808',
  },
  focused: {
    boxShadow: '0px 0px 0px 1px blue',
  },
  pressed: {
    backgroundColor: 'lightblue',
  },
  disabled: {
    opacity: 0.5,
  },
  buttons: {
    flexDirection: 'row',
    marginVertical: '1rem',
  },
});

export default DrawerNavigatorRoutes;
//export{Home, Room, Hall};
//export {DrawerNavigatorRoutes, HomeScreenStack};
